import React, { FC } from 'react';
import PostComposerContentText from 'app/modules/posts/modules/post/components/composer/postComposerContent/PostComposerContentText';
import { PostComposerContentProps } from 'app/modules/posts/modules/post/components/composer/PostComposerContent';
import PostComposerContentMediaAttachments from 'app/modules/posts/modules/post/components/composer/postComposerContent/PostComposerContentMediaAttachemnts';
import { PseudoPostType } from 'constants/post';
import PostsConfig from 'app/config/posts';
import PostComposerContentTikTokMeta from './postComposerContentTikTok/postComposerContentTikTokMeta';
import { TYPE_VIDEO } from '@kontentino/kontentino-constants/Posts';
import { VIDEO_STATUS_AVAILABLE } from '@kontentino/kontentino-constants/Video';

type Props = PostComposerContentProps;

const PostComposerContentTiktok: FC<Props> = ({
  value,
  onChange,
  onTextEditorInit,
  onTranslationEditorInit,
  swapTextTranslation,
}) => {
  const pseudoType = value.pseudoType;
  const canShowCustomThumbnailSlider =
    value.attachments.cards.length === 1 &&
    value.type === TYPE_VIDEO &&
    value.attachments.cards[0]?.medium?.type === 'video' &&
    value.attachments.cards[0]?.medium?.status === VIDEO_STATUS_AVAILABLE;

  return (
    <>
      <PostComposerContentText
        value={value}
        onChange={onChange}
        onTextEditorInit={onTextEditorInit}
        onTranslationEditorInit={onTranslationEditorInit}
        swapTextTranslation={swapTextTranslation}
      />
      {pseudoType && (
        <>
          {[PseudoPostType.Video, PseudoPostType.PhotoGallery].includes(
            pseudoType,
          ) && (
            <PostComposerContentMediaAttachments
              value={value}
              onChange={onChange}
              canSetupVideoThumbnail={canShowCustomThumbnailSlider}
              allowedFiles={
                PseudoPostType.Video === pseudoType ? ['video'] : ['image']
              }
              maxCount={
                [PseudoPostType.Photo, PseudoPostType.Video].includes(
                  pseudoType,
                )
                  ? PostsConfig.MIN_FILES_TO_ACCEPT
                  : PostsConfig.MAX_FILES_TO_ACCEPT
              }
            />
          )}
          <PostComposerContentTikTokMeta value={value} onChange={onChange} />
        </>
      )}
    </>
  );
};

export default PostComposerContentTiktok;
